import React from "react";

type Props = {value: number; onClick: () => void};

export default function ValueCell({value, onClick}: Props) {
  const content = value ? `${Math.round(value * 1000) / 10}%` : "-";

  return <td onClick={onClick}>{content}</td>;
}
